import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { DropzoneArea } from 'material-ui-dropzone';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close'
import Button from '@material-ui/core/Button';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    },
    cropContainer: {
        position: 'relative',
        //top: '0',
        //left: '0',
        //right: '0',
        //bottom: '80px',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

interface IDocumentUploadDocumentProps {
    submit: (event) => void;
    closeDialog: () => void;
    dialogOpen: boolean;
}

interface IDocumentUploadDocumentState {
    document: File | undefined;
}

class DocumentUploadDocument extends Component<IDocumentUploadDocumentProps & WithStyles<typeof styles>, IDocumentUploadDocumentState> {
    constructor(props) {
        super(props);

        this.state = {
            document: undefined
        };
    }

    public acceptedFileTypes = [
        '.jpeg',
        '.jpg',
        '.png',
        '.tif',
        '.pdf',
        '.xps',
        '.eml',
    ];

    componentDidMount() {
    }

    onClose = () => {
        this.props.closeDialog();
    }


    public render() {


        return (
            <Dialog open={this.props.dialogOpen} >
                <DialogTitle >Upload your Document
                    <IconButton aria-label="close" className={this.props.classes.closeButton} onClick={this.onClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    <DropzoneArea
                        onDrop={this.onDrop}
                        filesLimit={1}
                        dropzoneText="Drag & drop your document here or click to upload"
                        maxFileSize={10485760}
                        acceptedFiles={this.acceptedFileTypes}
                    />
                </DialogContent>

                <DialogActions>
                    <Button color="primary" variant="contained" onClick={this.onSubmit} endIcon={<CheckCircleOutline />} disabled={this.state.document === undefined}>Add Document To Basket</Button>
                </DialogActions>
            </Dialog>
        );
    }

    public onDrop = (newFile) => {
        this.setState({ document: newFile[0] });
    }

    public onSubmit = (event) => {
        this.props.submit(this.state.document)
    }
}

export default withStyles(styles)(DocumentUploadDocument);